export const createTableRowArray = (inputsValues) => {
    const array = []

    for (let i = 0; i < inputsValues.length; i++) {
        array.push(inputsValues[i].value)
    }

    return array
}